import React from 'react';

export type ErrorBoundaryProps = {
	children: React.ReactNode;
	fallback: React.ReactNode;
	onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
};

export type ErrorBoundaryState = {
	hasError: boolean;
	error?: Error;
};

// eslint-disable-next-line @repo/internal/react/no-class-components
export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: Error): ErrorBoundaryState {
		return {
			hasError: true,
			error,
		};
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
		this.props?.onError?.(error, errorInfo);
		// eslint-disable-next-line no-console
		console.error('TWG Common ErrorBoundary', error, errorInfo);
	}

	render(): React.ReactNode {
		if (this.state.hasError) {
			return this.props.fallback;
		}

		return this.props.children;
	}
}
